module.exports = __webpack_public_path__ + "static/img/2-3.ea42625.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/2-3.png
// module id = BVV2
// module chunks = 1